/**
 * Rich Text Element Schema
 */

import type { TiptapJSON } from '@ai-content-hub/content-kit';
import type { ElementSchema, RichTextFieldSchema } from '@ai-content-hub/content-kit';

export const defaultRichTextElementI18n = {
    en: { enterContent: 'Enter content...' },
    vi: { enterContent: 'Nhập nội dung...' },
};

export interface RichTextElementData {
    content: TiptapJSON | string | { markdown: string };
}

export const richTextElementSchema: ElementSchema<RichTextElementData> = {
    type: 'element-rich-text',
    title: 'Rich Text',
    description: 'Rich text content with formatting, headers, lists, and more',
    version: '1.0.0',
    category: 'text',
    icon: 'FileText',
    tags: ['rich-text', 'formatted', 'wysiwyg', 'content'],
    fields: [
        {
            name: 'content',
            type: 'rich-text',
            label: 'Content',
            description: 'Rich text content with formatting',
            required: true,
            tools: ['header', 'paragraph', 'list', 'quote', 'code', 'marker', 'inlineCode', 'image', 'audio', 'embed', 'table'],
        } as RichTextFieldSchema,
    ],
    defaultData: {
        content: {
            type: 'doc',
            content: [{ type: 'paragraph' }],
        },
    },
    i18n: defaultRichTextElementI18n,
};
